import { col } from "framer-motion/client";
import BaseListPresenter from "../../../base/BaseListPresenter";
import saveAs from "../../../saveAs";
import DialogSuccess from "./components/DialogSuccess";
import { dialog } from "../../../nq-component";

class EmployeeListPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
  }

  onClickAdd() {
    const collection = this.view.getCollectionName();
    this.view.navigateTo("/admin/employee/form");
  }

  onClickEdit(empDetails) {
    this.view.navigateTo(`/admin/employees/form/${empDetails?.id}`);
  }

  async onClickUpdateStatus(empDetails) {
    const object = empDetails;
    const collection = this.view.getCollectionName();

    object.status =
      object?.status === "InActive"
        ? "Active"
        : empDetails.status === "Active"
        ? "InActive"
        : null;

    if (object.applicant) {
      object.applicant = { id: object.applicant?.id };
    }
    if (object.coordinator) {
      object.coordinator = { id: object.coordinator?.id };
    }
    if (object.recruiter) {
      object.recruiter = { id: object.recruiter?.id };
    }
    await this.upsertUseCase.execute(collection, object);
    this.view.setObjects(this.objects);
    this.reset();
    this.getObjects();
  }

  onChangeFilter(type, value, field) {
    const newFilter = {};
    switch (type) {
      case "Pointer":
        if (Object.keys(value).length > 0) {
          newFilter[field] = { id: value.id };
        }
        break;
      case "Boolean":
        newFilter[field] = value;
        break;
      default:
        newFilter[field] = { $regex: value, $options: "i" };
    }

    this.where = { ...this.where, newFilter };

    this.filterSubmit(this.where);
  }

  async handleSubmit(formData, employee, coordinator) {
    const collection = "request";
    const status = "Pending";
    const data = { ...formData, employee, coordinator, status };

    data.attachmentArray = formData.attachment;

    delete data.attachment;

    const response = await this.upsertUseCase.execute(collection, data);

    if (response) {
      dialog.close();
      this.view.successModal();
    }
  }
}

export default EmployeeListPresenter;
